import { useMemo } from 'react';
import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const SliderHeader = ({
  bonuses,
  activeBonusId,
  arrowActiveStatus,
  onClickArrowLeft,
  onClickArrowRight
}) => {
  const { t } = useI18n();
  const { isLeftArrowHidden, isRightArrowHidden } = arrowActiveStatus;
  const bonusTitle = useMemo(() => {
    const { fullBonusTitle = '' } =
      bonuses?.find(
        (bonus) =>
          bonus?.bonusId === activeBonusId ||
          bonus?.freespinId === activeBonusId
      ) || {};
    return fullBonusTitle;
  }, [activeBonusId, bonuses]);

  return (
    <Box align="center" className={styles.container}>
      <Box className={styles.navigationContainer} gap="xxs">
        <Box
          onClick={!isLeftArrowHidden ? onClickArrowLeft : () => {}}
          className={clsx([
            styles.iconContainer,
            isLeftArrowHidden && styles.disabledIconContainer
          ])}
        >
          <Icon
            className={styles.navigationIcon}
            name="icons/general/nav/back-nav"
          />
        </Box>
        <Box
          onClick={!isRightArrowHidden ? onClickArrowRight : () => {}}
          className={clsx([
            styles.iconContainer,
            isRightArrowHidden && styles.disabledIconContainer
          ])}
        >
          <Icon
            className={styles.navigationIcon}
            name="icons/general/nav/next-nav"
          />
        </Box>
      </Box>
      <Box className={styles.bonusTitle} gap="xs">
        <AText size="m" color="po_txt_color_1" breed="R">
          {`${t('web.personaloffice.deposit.bonus.deposit.bonuscarusel')}:`}
        </AText>
        <AText size="m" color="po_txt_color_1" breed="B">
          {bonusTitle ||
            t('web.personaloffice.deposit.bonus.deposit.nonebonuses')}
        </AText>
      </Box>
    </Box>
  );
};
